import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { serviceConstants } from "src/app/constants/service.constants";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
  })
  export class EmailConfigurationService {
  
   // serviceConstants.apiURL: string = AppConsts.ApiServiceBaseUrl;
  
    jsonOptions: { responseType: 'json' | undefined, withCredentials: boolean | undefined } = { responseType: "json", withCredentials: true };
  
    constructor(private readonly http: HttpClient) { }
  
    getSummarySearchAsync(search: Partial<ConfigSearch>): Observable<ConfigSummary[]> {
      return this.http.post<ConfigSummary[]>(serviceConstants.apiURL + 'api/EmailSetUP/SearchSummary', search, this.jsonOptions);
    }
  
    fetchConfigAsync(configID: string): Observable<EmailConfiguration> {
      return this.http.get<EmailConfiguration>(serviceConstants.apiURL + 'api/EmailSetUP/FetchRecordByID/' + configID, this.jsonOptions);
    }
  
    insertConfigAsync(model: EmailConfiguration): Observable<any> {
      return this.http.post<any>(serviceConstants.apiURL + 'api/EmailSetUP/Insert', model, this.jsonOptions);
    }
  
    updateConfigAsync(model: EmailConfiguration): Observable<any> {
      return this.http.post<any>(serviceConstants.apiURL + 'api/EmailSetUP/Update', model, this.jsonOptions);
    }
  
    deleteConfigAsync(configID: string): Observable<any> {
      return this.http.get<any>(serviceConstants.apiURL + 'api/EmailSetUP/Delete/' + configID, this.jsonOptions);
    }
  
    smtpTestAsync(model: SMTPTestModel): Observable<any> {
      return this.http.post<any>(serviceConstants.apiURL + 'api/EmailSetUP/SMTPTest', model, this.jsonOptions);
    }
  
    imapTestAsync(model: EmailConfiguration): Observable<any> {
      return this.http.post<any>(serviceConstants.apiURL + 'api/EmailSetUP/IMAPTest', model, this.jsonOptions);
    }
  
  }
  
  export interface EmailConfiguration {
    EmailServerID?: string;
    EmailID?: string;
    EmailPwd?: string;
    EmailDisplayName?: string;
    SMTPHost?: string;
    SMTPPort?: string;
    SMTPSSL?: string;
    UserID?: string;
    SentItemsFolderName?: string;
    IMAPHost?: string;
    IMAPPort?: string;
    IMAPSSL?: string;
    EmailAccountTypeID?: number;
    EmailAccountType?: string;
    EmailAccountTypeCode?: string;
    TempFileID?: string;
    GSuiteFileID?: string;
    FileName?: string;
    FileExt?: string;
    MicrosoftTenantID?: string;
    MicrosoftClientID?: string;
    MicrosoftClientSecret?: string;
    OrgID?: string;
    LoggedUserID?: string;
    OrgGroupID?: string;
  }
  
  export interface ConfigSummary {
    EmailServerID?: string;
    EmailID?: string;
  }
  
  export interface ConfigSearch {
    OrgID?: string;
    UserID?: string;
    EmailID?: string;
  }
  
  export interface SMTPTestModel {
    Config?: EmailConfiguration;
    ToEmailID?: string;
    Subject?: string;
    Body?: string;
  }